import { PASSWORD_CHECK, checkErrorMinLength, checkErrorMaxLength } from '@chilecompra/react-kit/utils'
import { isValidRut } from './rut-utils'
import { onlyLettersPattern, DNI_FOREIGN_CHECK } from '../../config/settings/regexes'
import { ALLOWED_FOREIGN_DOCUMENT_REGEX } from '../../config/settings/constants'
import { isNaturalPerson } from './helpers'
import { getRepresentativeByDni } from './filters'

/**
 * Check if the passwords meet the requirements.
 */
export const checkInputErrorPassword = customMessage => value =>
  PASSWORD_CHECK.test(value) ? '' : customMessage || 'Tu contraseña no cumple con los requisitos mínimos.'

/**
 * Check if the passwords matchs.
 */
export const checkInputErrorSamePasswords = (passwordToCompare, customMessage) => value =>
  value === passwordToCompare ? '' : customMessage || 'Esta contraseña no coincide con la anterior.'

/**
 * Check if the given string value is a National DNI.
 */
export const checkInputNationalDniError = customMessage => value => {
  return isValidRut(value) ? customMessage || 'Has ingresado un RUT chileno' : ''
}

/**
 * Check if the given Input value satisfy the minimum length allowed.
 */
export const checkInputErrorMinLength = (minLength, customMessage) => value => {
  const isString = typeof value === 'string'

  if (checkErrorMinLength(value, minLength)) {
    return ''
  }

  return (
    customMessage ||
    (isString
      ? `Este campo debe tener un mínimo de ${minLength} caracteres.`
      : `Este campo debe tener un mínimo de ${minLength} dígitos.`)
  )
}

/**
 * Check if the given Input value satisfy the maximum length allowed.
 */
export const checkInputErrorMaxLength = (maxLength, customMessage) => value => {
  const isString = typeof value === 'string'

  if (checkErrorMaxLength(value, maxLength)) {
    return ''
  }

  return (
    customMessage ||
    (isString
      ? `Este campo excede el máximo de ${maxLength} caracteres permitido.`
      : `Este campo permite hasta ${maxLength} dígitos.`)
  )
}

/**
 * Check if the given phone number starts with one of the specified numbers.
 * @param {string} customMessage - The custom error message to display if validation fails.
 * @param {Array} startsWith - An array of numbers the phone number should start with.
 * @return {function} - A function that takes a value and returns an error message if validation fails.
 */
export const checkInputErrorStartsWith = (customMessage, startsWith) => value => {
  const startsWithPattern = new RegExp(`^[${startsWith.join('')}]`)
  return startsWithPattern.test(value) ? '' : customMessage
}

/**
 * Check if the given value is only letters.
 */
export const formatOnlyLetters = value => value.replace(onlyLettersPattern, '')

/**
 * Check if the given value is an URL with only letters and numbers.
 */

export const checkInputErrorUrl = customMessage => value => {
  const regex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)+([/a-zA-Z0-9]*)*$/
  return regex.test(value) ? '' : customMessage
}

/**
 * Validates the input for foreign documents, allowing letters, numbers, and special characters.
 */
export const formatForeignDocument = value => {
  if (!value) return ''

  return value
    .split('')
    .filter(char => ALLOWED_FOREIGN_DOCUMENT_REGEX.test(char))
    .join('')
}

/**
 * Check if the given value is exist in representatives.
 */
export const checkErrorDniInRepresentatives = (list, customMessage) => value => {
  const exist = getRepresentativeByDni(list, value)
  // If the current dni exist inside representant, then return error
  return !exist ? '' : customMessage || 'Rut ya existe en lista representantes.'
}

/**
 * Check if the given string value is a National DNI.
 */
export const checkNationalDNIError = customMessage => value => {
  return isValidRut(value) ? customMessage || 'Has ingresado un RUT chileno' : ''
}

/**
 * Check if the given string value has a DNI valid for person.
 */
export const checkErrorDniBusiness = customMessage => value => {
  return isNaturalPerson(value) ? '' : customMessage || 'No se permiten personas jurídicas'
}

/**
 * Check if the given string value has a DNI foreign valid.
 */
export const checkErrorDniForeign = customMessage => value =>
  DNI_FOREIGN_CHECK.test(value) ? '' : customMessage || 'El dni es inválido.'
